import { Params, redirect } from "react-router-dom";
import axios from "axios";
import { WALLET_ADDRESS_REGEX } from "@/utils/validation";
import { DynamicUserProfile } from "@/types/dynamic";

const API_URL =
  import.meta.env.VITE_LGT_SERVER_URL || "https://api.legitimate.tech";

export const collectionLoader = async ({
  params: { walletAddressOrUsername },
}: {
  params: Params<string>;
}) => {
  if (!walletAddressOrUsername) {
    return redirect("/");
  }

  let walletAddress;
  let user: DynamicUserProfile | undefined = undefined;
  const endpoint = new URL("/owners/user", API_URL);

  if (WALLET_ADDRESS_REGEX.test(walletAddressOrUsername)) {
    walletAddress = walletAddressOrUsername;

    endpoint.searchParams.append("address", walletAddressOrUsername);
    const url = endpoint.toString();

    try {
      const response = await axios.get(url);
      const data = response.data;

      if (data?.username) {
        return redirect(`/${data.username}`);
      }

      user = data;
    } catch {
      // User data unavailable, continue with undefined
    }
  } else {
    endpoint.searchParams.append("username", walletAddressOrUsername);

    const url = endpoint.toString();

    try {
      const response = await axios.get(url);
      const data = response.data;

      if (data?.address) {
        walletAddress = data.address;
        user = data;
      } else {
        return redirect("/");
      }
    } catch {
      return redirect("/");
    }
  }

  const response = await fetch(`${API_URL}/tags/collection/${walletAddress}`);

  const { tags } = await response.json();

  return { user, tags };
};
